'use strict';
import angular from 'angular';
import moment from 'moment';
import posMatchbackDetailsHtmlUrl from './views/posMatchbackDetails.html';

let app = angular.module('app.posMatchbackDetailsComponent', []);

app.component('posMatchbackDetails', {
    bindings: {
        posMatchbackDetails: '<',
    },
    templateUrl: posMatchbackDetailsHtmlUrl,
    controller: function () {
        let self = this;
        self.posList = [];
        self.tableEmpty = true;
        if (!self.posMatchbackDetails) {
            self.posMatchbackDetails = [];
        } else {
            // This field is sent to us from the backend as a string.
            self.posMatchbackDetails = JSON.parse(self.posMatchbackDetails);
        }
        self.posMatchbackDetails.forEach((posEntry) => {
            const entry = {};
            entry.posId = posEntry.pos_id;
            entry.filename = posEntry.filename;
            entry.status = posEntry.status;
            entry.timestamp = moment.unix(posEntry.timestamp).format('YYYY-MM-DD HH:mm:ss');
            self.posList.push(entry);
            self.tableEmpty = false;
        });
    }
});
